import React, { useState, useEffect, forwardRef } from 'react';
import IconCalendar from '../../audi-ui-components/icons/CalendarEvents';
import IconTime from '../../audi-ui-components/icons/Time';
import Modal from '../../audi-ui-components/Modal';
import NavBar from '../../audi-ui-components/NavBar';
import DatePicker from 'react-datepicker';
import cn from 'classnames';

const DateTimeModule = ({
  title, minDate, maxDate,
  values, errors, touched, submitCount, setFieldValue, setFieldTouched,
  isIframed,
  theme,
}) => {
  
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  const formatDate = (d) => {
    if (!(d instanceof Date)) {
      return "";
    }
    let day = d.getDate();
    let mon = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()];
    let year = d.getFullYear();
    return `${day} ${mon} ${year}`;
  }
  
  useEffect(()=>{
    setTimeout(() => {
      setFieldValue("preferredTestDriveDate", "");
    }, 50);
  }, []);
  
  const DPInput = forwardRef(({ onClick }, ref) => (
    <button type="button" className="date-button aui-textlink" onClick={onClick} ref={ref}>
      <IconCalendar small /> <span className="aui-color-text-gray50">Add Date &amp; Time *</span>
    </button>
  ));
  
  const DPInputValue = forwardRef(({ value, onClick }, ref) => (
    <button type="button" className="date-button aui-textlink" onClick={onClick} ref={ref}>
      <IconCalendar small /> <b className="aui-font-extended">{value}</b>
    </button>
  ));
  
  return (
    <div className="form-module date-time-module">
      {title && <p className="aui-headline-5 mb-3"><b>{title}</b></p>}
      
      {!values.preferredTestDriveDate && <p>
        {!isIframed && <button type="button" className="date-button aui-textlink" onClick={()=>{ setShowDatePicker(true); }}>
          <IconCalendar small /> <span className="aui-color-text-gray50">Add Date &amp; Time *</span>
        </button>}
        {isIframed && <DatePicker
          selected={values.preferredTestDriveDate && values.preferredTestDriveDate instanceof Date && !isNaN(values.preferredTestDriveDate) ? values.preferredTestDriveDate : ""}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            setFieldValue("preferredTestDriveDate", date);
            setFieldTouched("preferredTestDriveDate", true, false);
            setShowDatePicker(false);
          }}
          customInput={<DPInput />}
        />}
      </p>}
      
      {values.preferredTestDriveDate && <div className="p-3 with-value mb-3">
        {!isIframed && <button type="button" className="date-button has-value aui-textlink " onClick={()=>{ setShowDatePicker(true); }}>
          <IconCalendar small /> <b className="aui-font-extended">{formatDate(values.preferredTestDriveDate)}</b>
        </button>}
        {isIframed && <DatePicker
          selected={values.preferredTestDriveDate && values.preferredTestDriveDate instanceof Date && !isNaN(values.preferredTestDriveDate) ? values.preferredTestDriveDate : ""}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            setFieldValue("preferredTestDriveDate", date);
            setFieldTouched("preferredTestDriveDate", true, false);
            setShowDatePicker(false);
          }}
          dateFormat="dd/MM/yyyy"
          customInput={<DPInputValue />}
        />}
        <p className="mb-2 mt-3">Select a time you're available</p>
        <div className="row">
          <div className="col-auto"><IconTime small /></div>
          <div className="col">
            <NavBar
              actions={[{text: "AM"}, {text: "PM"}]}
              activeIndex={values.preferredTestDriveTime === "Morning" ? 0 : values.preferredTestDriveTime === "Afternoon" ? 1 : null}
              onActionClick={(i) => {
                setFieldTouched("preferredTestDriveTime", true, false);
                let times = ["Morning", "Afternoon"];
                setFieldValue("preferredTestDriveTime", times[i]);
              }}
              theme={theme === "light" ? "black" : null}
              className={values.preferredTestDriveTime ? "has-value" : ""}
            />
          </div>
        </div>
      </div>}
      
      {errors.preferredTestDriveDate && (touched.preferredTestDriveDate || submitCount > 0) && <p className="aui-textfield__error">{errors.preferredTestDriveDate}</p>}
      {errors.preferredTestDriveTime && (touched.preferredTestDriveTime || submitCount > 0) && <p className="aui-textfield__error">{errors.preferredTestDriveTime}</p>}
      
      <Modal isActive={showDatePicker} variant="layer" className="datepicker-modal" closeButton close={()=>{ setShowDatePicker(false); }}>
        <div className="aui-color-black aui-color-text-light p-3 datepicker-modal__header">
          <b className="aui-font-extended">Select a date</b>
        </div>
        <DatePicker
          selected={values.preferredTestDriveDate && values.preferredTestDriveDate instanceof Date && !isNaN(values.preferredTestDriveDate) ? values.preferredTestDriveDate : ""}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            setFieldValue("preferredTestDriveDate", date);
            setFieldTouched("preferredTestDriveDate", true, false);
            setShowDatePicker(false);
          }}
          inline
        />
      </Modal>
    </div>
  );
};

export default DateTimeModule;
